import api from "!../../../../../../style-loader/dist/runtime/injectStylesIntoStyleTag.js";
            import content from "!!../../../../../../css-loader/dist/cjs.js??ruleSet[1].rules[0].use[1]!../../../../../../postcss-loader/dist/cjs.js!../../../../../../sass-loader/dist/cjs.js??ruleSet[1].rules[0].use[3]!./AddToBagVerification.module.scss";

var options = {};

options.insert = "head";
options.singleton = false;

var update = api(content, options);



export default content.locals || {};